import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { useAuthStore, setRouter } from '@/stores/auth'
import './assets/main.css'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// ルーターをauthストアに注入（循環参照を回避）
setRouter(router)

// 認証の初期化を待ってからアプリをマウント
// 初期化中は index.html 内のローディング表示が見える
const authStore = useAuthStore()
authStore.initializeAuth().then(() => {
  app.mount('#app')
})
